import { Tags } from "@/enum/tags";
import { CreateExtractSchedulesRequest, CreateExtractSchedulesResponse, JobRow, SchedulerSummary } from "@/pages/tax/extracao-nf-ofm/dtos/ofm-dtos";
import { apiSlice } from "@/services/http";
import { getFilenameFromContentDisposition, sanitizeFilename } from "@/utils/http";

export const ofmApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOfmSchedulers: builder.query<{ items: SchedulerSummary[] }, void>({
      query: () => "/ofm/schedulers",
      providesTags: [Tags.OFM_LIST_SCHEDULER],
    }),

    getOfmSchedulerJobs: builder.query<{ items: JobRow[] }, { schedulerId: string }>({
      query: ({ schedulerId }) => `/ofm/schedulers/${schedulerId}/jobs`,
      providesTags: [Tags.OFM_LIST_JOBS],
    }),

    createExtractSchedules: builder.mutation<
      CreateExtractSchedulesResponse,
      CreateExtractSchedulesRequest
    >({
      query: (body) => ({ url: "/ofm/extract/schedule", method: "POST", body }),
      invalidatesTags: [Tags.OFM_LIST_SCHEDULER],
    }),

    downloadScheduler: builder.mutation<
      { blob: Blob; filename: string; size: number; headers: Record<string, string> },
      string
    >({
      query: (id) => ({
        url: `/ofm/schedulers/${id}/download`,
        method: "GET",
        responseHandler: async (resp: Response) => {
          const blob = await resp.blob();
          const headersLower = Object.fromEntries(
            Array.from(resp.headers.entries()).map(([k, v]) => [k.toLowerCase(), v])
          );

          const cd = headersLower["content-disposition"];
          let filename = getFilenameFromContentDisposition(cd) ?? `ofm_${id}.zip`;
          filename = sanitizeFilename(filename, `ofm_${id}.zip`);

          return { blob, filename, size: blob.size, headers: headersLower };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateExtractSchedulesMutation,
  useGetOfmSchedulersQuery,
  useGetOfmSchedulerJobsQuery,
  useDownloadSchedulerMutation,
} = ofmApi;
